import { IonAlert, IonButton, IonIcon, IonInput, IonItem, IonTextarea } from '@ionic/react';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FieldError, NormalText, Spacer, StrongText, Title } from '../../components/common';
import Mobiscroll from '../../components/mobiscroll';
import Basket from '../../lib/basket';
import moment from '../../lib/moment';
import { withTranslation } from '../../lib/translate';
import { forwardTo, isWebConfig, validateForm } from '../../lib/utils';
import Layout from '../../components/layout';
import { withRouter } from 'react-router';
import { getConfig } from '../../appConfig';
import FieldWrapper from '../../components/fieldWrapper';
import { chevronDownOutline } from 'ionicons/icons';
import Modal from '../../components/modal';

const { SelectOption } = Mobiscroll;

class GiftVouchers extends Component {
	constructor(props) {
		super(props);
		this.state = {
			giftVoucherValues: [],
			email: '',
			sender_email: this.props.profile.email || '',
			sender_name: this.props.profile.first_name || '',
			logo_image: this.props.clientProfile.logo_image || '',
			logo_image_light: this.props.clientProfile.logo_image_light || this.props.clientProfile.logo_image || '',
			proceedeToOrderSummaryModalOpen: false,
		};
		this.voucherValidator = {
			email: { type: 'email', required: true },
			sender_email: { type: 'email', required: true },
		};
	}
	componentDidMount() {

		const voucher = this.props.location?.state?.voucher;

		this.setState({
			giftVoucherValues: getConfig().general.giftVouchers,
			giftVoucherAmount: getConfig().general.giftVouchers[1],
		});
		if (voucher) {
			this.setState({
				personal_message: voucher.personal_message,
				email: voucher.recipient_email,
				giftVoucherDate: voucher.send_on_date,
				giftVoucherAmount: voucher.points_value / 100,
				sender_email: voucher.sender_email || this.props.profile.email,
				sender_name: voucher.sender_name,
				processing_fee: Basket.getProcessingFee() * 100,

			});
		}
	}
	proceedeToOrderSummary = () => {
		const { email, sender_email } = this.state;
		const { dispatch, restaurants, profile } = this.props;
		let voucherErrors = validateForm(this.voucherValidator, { email, sender_email });
		this.setState({ voucherErrors });
		if (Object.keys(voucherErrors).length === 0) {
			const data = {
				personal_message: this.state.personal_message,
				recipient_email: this.state.email,
				send_on_date: this.state.giftVoucherDate,
				points_value: this.state.giftVoucherAmount * 100,
				sender_email: this.state.sender_email || this.props.profile.email,
				sender_name: this.state.sender_name,
			};

			Basket.reset();
			const uuid = `${profile.id}_${Date.now()}`;
			Basket.setUUID(uuid);
			Basket.setCollectionTime(null);
			Basket.addToBasket({
				item: { productPrice: this.state.giftVoucherAmount, productName: 'eGift Voucher', giftVoucherData: data },
				quantity: 1,
			});
			Basket.setDeliveryOption({
				id: 'gift-vouchers',
			});
			Basket.setGift(data);

			Basket.setRestaurant(restaurants.find((restaurant) => restaurant.name === 'Vouchers'));
			Basket.setServicePercentage(0);
			dispatch({
				type: 'SET_GIFT_VOUCHER_DATA',
				value: data,
			});
			data.processing_fee = Basket.process_fee_value * 100;
			forwardTo('/gift-voucher', {
				voucher: data,
				hasEdit: true,
			});
		}
	};
	formatVoucherValues = () => {
		const values = this.state.giftVoucherValues;
		const data = values.map((value) => {
			return { text: Basket.formatPrice(value), value };
		});

		return data;
	};
	getDateArray = (obj) => {
		var start = obj.startDate.clone();
		var end = obj.endDate.clone();
		var res = [];
		while (start.isBefore(end)) {
			res.push(start.toDate());
			start.add(1, 'd');
		}
		return res;
	};
	formatDateValues = () => {
		const startDate = moment();
		const endDate = moment().add(30, 'days');
		const daysInBetween = this.getDateArray({ startDate, endDate });
		const data = daysInBetween.map((date) => {
			return {
				text: moment(date).format('DD MMMM YYYY'),
				value: moment(date).format('MM/DD/YYYY'),
			};
		});
		return data;
	};
	updateGiftVoucher = () => {
		const { email, sender_email } = this.state;
		let voucherErrors = validateForm(this.voucherValidator, { email, sender_email });
		this.setState({ voucherErrors });
		if (Object.keys(voucherErrors).length === 0) {
			const data = {
				gift_id: this.props.location?.state?.voucher?.id,
				personal_message: this.state.personal_message,
				recipient_email: this.state.email,
				send_on_date: this.state.giftVoucherDate,
			};

			this.props.dispatch({
				type: 'UPDATE_GIFT_VOUCHER',
				data,
			});
		}
	};
	render() {
		const { __ } = this.props;
		const dateValues = this.formatDateValues();
		const isSent = this.props.location?.state?.isSent ? true : false;
		const voucher = this.props.location?.state?.voucher;
		const title = isSent ? 'Update gift voucher' : voucher ? 'Edit gift voucher' : 'Send gift voucher';


		return (
			<Layout showHamburger title={__(title)} hideSecondToolbar={true} color="transparent" scrollY={false} backHandler={this.backHandler}>
				<div className="absolute-content scrollable-y">

					<Title className="block">{__(title)}</Title>
					<Spacer size={2} />
					{this.props.clientProfile.gift_voucher_description && <NormalText>{__(this.props.clientProfile.gift_voucher_description)}</NormalText>}
					<div className="input-field-container">
						<StrongText>{__('How much do you want to send?')}</StrongText>
						<IonItem disabled={isSent} lines="none" className="input-field-wrapper dropdown-field">
							<SelectOption
							theme='ios'
								disabled={isSent}
								cssClass={isWebConfig() ? 'web' : ''}
								display="center"
								onSet={(e, a) =>
									this.setState({
										giftVoucherAmount: a.getVal(),
									})
								}
								data={this.formatVoucherValues()}
								label="Location"
								value={this.state.giftVoucherAmount}
								cancelText={__('Cancel')}
								setText={__('OK')}
							/>
							<IonIcon icon={chevronDownOutline} />

						</IonItem>
					</div>
					<div className="input-field-container">
						<StrongText>{__('Where shall we send the gift voucher?')} *</StrongText>
						<FieldWrapper error={this.state.voucherErrors?.email}>
							<IonInput
								onIonInput={(e) => this.setState({ email: e.target.value })}
								type="email"
								pattern="email"
								inputmode="email"
								value={this.state.email}
								placeholder={__('Recipient email address')}
							></IonInput>
						</FieldWrapper>

					</div>
					<div className="input-field-container">
						<StrongText>{__('Enter a personal message')}</StrongText>

						<IonItem lines="none" className="input-field-wrapper">
							<IonTextarea
								rows={5}
								placeholder={__('Your message')}
								onIonInput={(e) => this.setState({ personal_message: e.target.value })}
								value={this.state.personal_message}
							></IonTextarea>
						</IonItem>
					</div>
					<div className="input-field-container">
						<StrongText>{__('When shall we send the voucher?')}</StrongText>

						<IonItem lines="none" className="input-field-wrapper  dropdown-field">
							<SelectOption
							theme='ios'
								cssClass={isWebConfig() ? 'web' : ''}

								display="center"
								onSet={(e, a) =>
									this.setState({
										giftVoucherDate: a.getVal(),
									})
								}
								data={dateValues}
								label="Location"
								value={this.state.giftVoucherDate}
								cancelText={__('Cancel')}
								setText={__('OK')}
								onInit={() => {
									if (!this.state.giftVoucherDate) {
										this.setState({ giftVoucherDate: dateValues[0].value });
									}
								}}
							/>
							<IonIcon icon={chevronDownOutline} />

						</IonItem>
					</div>
					<Spacer size={2} />
					<Title className="block">{__('Your details')}</Title>
					<Spacer size={2} />
					<div className="input-field-container">
						<StrongText>{__('Your name (sender)')}</StrongText>

						<IonItem lines="none" className={`input-field-wrapper ${this.props.auth.loggedIn && this.props.profile.first_name !== '' ? 'disabled-wrapper':''}`}>
							<IonInput
								onIonInput={(e) => this.setState({ sender_name: e.target.value })}
								type="email"
								pattern="email"
								inputmode="email"
								value={this.state.sender_name}
								placeholder={__("Sender's name")}
							></IonInput>
						</IonItem>
					</div>
					<div className="input-field-container">
						<StrongText>{__('Your email address (sender)')} *</StrongText>
						<IonItem lines="none" className={`input-field-wrapper ${this.props.auth.loggedIn ? 'disabled-wrapper':''}`}>
							<IonInput
								onIonInput={(e) => this.setState({ sender_email: e.target.value })}
								type="email"
								pattern="email"
								inputmode="email"
								value={this.state.sender_email}
								placeholder={__("Sender's email address")}
							></IonInput>
						</IonItem>
						{this.state.voucherErrors?.sender_email && <FieldError className="field-error" value={__(this.state.voucherErrors.sender_email)} />}
					</div>

					<Spacer size={2} />
					{isSent ? (
						<IonButton disabled={this.state.email.length === 0} onClick={(e) => { e.target.focus(); this.updateGiftVoucher() }} color="primary" expand="block">
							{__('Update gift voucher')}
						</IonButton>
					) : (
						<IonButton
							disabled={this.state.email.length === 0}
							onClick={() => {
								if (voucher) {
									this.proceedeToOrderSummary();
								} else {
									let voucherErrors = validateForm(this.voucherValidator, { email: this.state.email, sender_email: this.state.sender_email });
									this.setState({ voucherErrors });
									if (Object.keys(voucherErrors).length === 0) {
										this.setState({ proceedeToOrderSummaryModalOpen: true });
									}
								}
							}}
							color="primary"
							expand="block"
						>
							{voucher ? __('Edit') : __('Continue')}
						</IonButton>
					)}
				</div>
				<Modal
					className={`modal-type-alert`}
					isOpen={this.state.proceedeToOrderSummaryModalOpen}
					onDidDismiss={() => this.setState({ proceedeToOrderSummaryModalOpen: false })}
				>
					<div style={{textAlign:'center',display:'grid',justifyItems:'center'}}>

					<Spacer size={5} />
					<StrongText className='centered block'>{__('Confirm your email')}</StrongText>
					<Spacer size={1}/>
					<NormalText className='centered block'>{`${__('Your voucher confirmation will be sent to the following email address:')} ${this.state.sender_email}`}</NormalText>
					<Spacer size={5} />
					
					</div>
					<IonButton expand="block" className='' onClick={() => this.proceedeToOrderSummary()}>
						{__('OK')}
					</IonButton>
					<Spacer size={2}/>
					<IonButton expand="block" color='secondary' className='link' onClick={() => this.setState({ proceedeToOrderSummaryModalOpen: false })}>
						{__('Cancel')}
					</IonButton>
				</Modal>

			</Layout>
		);
	}
}

const stateToProps = (state) => {
	return {
		sentGiftVouchers: state.orders.sentGiftVouchers || [],
		redeemedGiftVoucher: state.orders.redeemedGiftVoucher || null,
		auth: state.profile.auth,
		navConfig: state.common.navConfig,
		clientProfile: state.common.clientProfile,
		clientStyles: state.common.clientStyles,
		profile: state.profile.profile,
		restaurants: state.restaurants.restaurants || [],
	};
};

export default withRouter(withTranslation(connect(stateToProps)(GiftVouchers)));
